<template>
  <!--  <v-btn @click="$store.dispatch('wallet/toggleOpen')" text class="px-0 mt-1">-->
  <!--    <span class="svg-icon svg-icon-2x btn" title="کیف پول">-->
  <!--         <svg-->
  <!--             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">-->
  <!--           <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect x="0" y="0" width="24" height="24"/><circle fill="#000000" opacity="0.3" cx="20.5" cy="12.5" r="1.5"/><rect-->
  <!--               fill="#000000" opacity="0.3" transform="translate(12.000000, 6.500000) rotate(-15.000000) translate(-12.000000, -6.500000) " x="3" y="3" width="18" height="7" rx="1"/><path-->
  <!--               d="M22,9.33681558 C21.5453723,9.12084552 21.0367986,9 20.5,9 C18.5670034,9 17,10.5670034 17,12.5 C17,14.4329966 18.5670034,16 20.5,16 C21.0367986,16 21.5453723,15.8791545 22,15.6631844 L22,18 C22,19.1045695 21.1045695,20 20,20 L4,20 C2.8954305,20 2,19.1045695 2,18 L2,6 C2,4.8954305 2.8954305,4 4,4 L20,4 C21.1045695,4 22,4.8954305 22,6 L22,9.33681558 Z"-->
  <!--               fill="#000000"/>-->
  <!--           </g>-->
  <!--         </svg>-->
  <!--     </span>-->
  <!--  </v-btn>-->

  <!--  append-icon="mdi-currency-rial"-->
  <!-- <div :class="['d-flex flex-row justify-content-center  mt-2 menu', { 'hiddenInMobileH': hideInMobile }]"> -->
  <div :class="['d-flex justify-content-ceter mt-2 rounded']">
    <v-text-field class="centered-input priceWallet menu-text mx-0 px-0 py-0 my-0 mt-0 pt-0 rounded" v-model="balance"
                  full-width readonly prepend-inner-icon="اعتبار" append-icon="mdi-currency-rial">
      <!-- <template v-slot:prepend-inner class="mt-0">
        <div class="append-icon"></div> -->
      <!--        <img src="/media/etebar.svg/media/etebar.svg" width="45px" height="30px"></img>-->
      <!-- </template> -->

    </v-text-field>
    <v-btn color="blue" class="priceWalletButton  px-0  my-0 mx-0" @click="$store.dispatch('wallet/toggleOpen')" style="background-color: #6cdb72!important;">
      <v-icon class="plus" small>
        mdi-plus
      </v-icon>
    </v-btn>
  </div>


  <!--  <b-dropdown-->
  <!--      size="sm"-->
  <!--      variant="link"-->
  <!--      toggle-class="topbar-item text-decoration-none"-->
  <!--      no-caret-->
  <!--      right-->
  <!--      no-flip-->
  <!--  >-->
  <!--    <template v-slot:button-content>-->
  <!--      <v-btn  text class="px-0 mt-1">-->
  <!--             <span class="svg-icon svg-icon-2x btn pl-0" title="کیف پول">-->
  <!--               <svg-->
  <!--                   xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">-->
  <!--                 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect x="0" y="0" width="24" height="24"/><circle fill="white" opacity="0.3" cx="20.5" cy="12.5" r="1.5"/><rect-->
  <!--                     fill="white" opacity="0.3" transform="translate(12.000000, 6.500000) rotate(-15.000000) translate(-12.000000, -6.500000) " x="3" y="3" width="18" height="7" rx="1"/>-->
  <!--                   <path  id="wallet"-->
  <!--                          d="M22,9.33681558 C21.5453723,9.12084552 21.0367986,9 20.5,9 C18.5670034,9 17,10.5670034 17,12.5 C17,14.4329966 18.5670034,16 20.5,16 C21.0367986,16 21.5453723,15.8791545 22,15.6631844 L22,18 C22,19.1045695 21.1045695,20 20,20 L4,20 C2.8954305,20 2,19.1045695 2,18 L2,6 C2,4.8954305 2.8954305,4 4,4 L20,4 C21.1045695,4 22,4.8954305 22,6 L22,9.33681558 Z"-->
  <!--                          fill="white"/>-->
  <!--                 </g>-->
  <!--               </svg>-->
  <!--           </span>-->
  <!--          <span class="badge badge-white mr-2 ml-0">{{wallet.balance | rial}} ریال</span>-->
  <!--      </v-btn>-->
  <!--    </template>-->
  <!--    <b-dropdown-text tag="div" class="min-w-md-350px">-->
  <!--      <template>-->
  <!--        <v-card-->
  <!--            class="mx-auto"-->
  <!--            color="grey lighten-4"-->
  <!--            max-width="600"-->
  <!--        >-->
  <!--          <v-card-title>-->
  <!--            <div class="d-flex flex-column w-100">-->
  <!--              <div class="d-flex flex-row flex-nowrap">-->
  <!--                <b-dropdown-item-button-->
  <!--                    icon-->
  <!--                    class="align-self-start backButton"-->
  <!--                    size="28"-->
  <!--                >-->
  <!--                  <v-icon>mdi-arrow-right-thick</v-icon>-->
  <!--                </b-dropdown-item-button>-->
  <!--                <p class="w-100 text-center titleWallet">کیف پول</p>-->
  <!--              </div>-->


  <!--              <div class="d-flex flex-row justify-content-center w-100 mt-4 align-item-stretch">-->
  <!--                  <v-text-field-->
  <!--                      class="centered-input priceWallet mx-0 px-0 py-0 my-0 "-->
  <!--                      append-icon="mdi-currency-rial"-->
  <!--                      v-model="balance"-->
  <!--                      filled-->
  <!--                      rounded-->
  <!--                      dense-->
  <!--                      readonly-->
  <!--                      hide-details-->
  <!--                  ></v-text-field>-->
  <!--                  <v-btn color="blue" class="priceWalletButton  px-0 pt-6 pb-6  my-0 mx-0" @click="$store.dispatch('wallet/toggleOpen')">-->
  <!--                    <v-icon>-->
  <!--                      mdi-plus-->
  <!--                    </v-icon>-->
  <!--                  </v-btn>-->
  <!--              </div>-->
  <!--            </div>-->


  <!--          </v-card-title>-->
  <!--          <p class="wrap w-100 gray text-center">{{ $t('WALLET.ChargeWalletButtonDescription') }}</p>-->
  <!--          <v-img-->
  <!--            src="media/money.png"-->
  <!--            width="350px"-->
  <!--            class=""-->
  <!--          >-->

  <!--          </v-img>-->





  <!--&lt;!&ndash;          <v-sheet color="transparent">&ndash;&gt;-->
  <!--&lt;!&ndash;            <v-sparkline&ndash;&gt;-->
  <!--&lt;!&ndash;                :key="String(avg)"&ndash;&gt;-->
  <!--&lt;!&ndash;                :smooth="16"&ndash;&gt;-->
  <!--&lt;!&ndash;                :gradient="['#f72047', '#ffd200', '#1feaea']"&ndash;&gt;-->
  <!--&lt;!&ndash;                :line-width="3"&ndash;&gt;-->
  <!--&lt;!&ndash;                :value="heartbeats"&ndash;&gt;-->
  <!--&lt;!&ndash;                auto-draw&ndash;&gt;-->
  <!--&lt;!&ndash;                stroke-linecap="round"&ndash;&gt;-->
  <!--&lt;!&ndash;            ></v-sparkline>&ndash;&gt;-->
  <!--&lt;!&ndash;          </v-sheet>&ndash;&gt;-->
  <!--        </v-card>-->
  <!--      </template>-->
  <!--    </b-dropdown-text>-->
  <!--  </b-dropdown>-->



</template>

<script>
const exhale = ms =>
    new Promise(resolve => setTimeout(resolve, ms))

export default {
  name: "WalletOpenButton",
  data: () => ({
    checking: false,
    heartbeats: [],
  }),
  props: {
    hideInMobile: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    let classes = window.document.querySelectorAll(".priceWallet .v-input__control .v-text-field__slot *");
    for (let c of classes) {
      c.classList.add('on-scroll-shoed');
    }

  },
  computed: {
    avg() {
      const sum = this.heartbeats.reduce((acc, cur) => acc + cur, 0)
      const length = this.heartbeats.length

      if (!sum && !length) return 0

      return Math.ceil(sum / length)
    },

    balance() {
      return this.persian(this.convertToHumanReadablePrice(this.wallet.balance))
    }
  },

  created() {
    this.takePulse(false)
  },

  methods: {
    heartbeat() {
      return Math.ceil(Math.random() * (120 - 80) + 80)
    },
    async takePulse(inhale = true) {
      this.checking = true

      inhale && await exhale(1000)

      this.heartbeats = Array.from({ length: 20 }, this.heartbeat)

      this.checking = false
    },

    convertToHumanReadablePrice(input) {
      return (input ? input.toString() : "0").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

  },
}
</script>

<style scoped>
.backButton {
  margin-top: -1rem;
  margin-right: -1.2rem;
}

.titleWallet {
  margin-top: -0.52rem;
  margin-left: 2rem;
}

.centered-input>>>input {
  text-align: center;
}

.priceWallet {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  /*border-bottom-right-radius: 0%;
  border-top-right-radius: 0%;*/
}

.priceWalletButton {
  box-shadow: none;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  background-color: #6cdb72!important;
  border-bottom-left-radius: 20%;
  border-top-left-radius: 20%;
  /*border-radius: 15%;*/


  min-width: 2.5rem !important;
  height: 2.5rem !important;
  background-color: #4ba5de !important;
  color: white
  /*color: white;*/

}
</style>
<style>
@media only screen and (max-width: 990px) {
  .priceWallet .v-input__control {
    width: auto !important;
  }

  .priceWallet {
    margin-top: -.5rem !important;
    margin-right: 2rem !important;
  }

  .priceWallet+* {
    margin-top: -.5rem !important;
    margin-left: 1rem !important;
  }

  .hiddenInMobileH {
    display: none !important;
  }
}

.priceWallet .v-input__control {
  min-width: 20px;
  min-height: 2.5rem !important;
  height: 2.5rem !important;
  background-color: rgba(256, 256, 256, 0.2) !important;
  color: white;
  /*background-color: hsla(0, 0%, 100%, 0.12) !important;*/
  width: 12vw;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.priceWallet .v-input__control .v-input__slot * {
  padding: 0 0.5rem;
  min-height: 2.5rem !important;
  height: 2.5rem !important;
  font-size: 1.2rem;
  font-weight: bold;
  color: white;
  font-family: 'vazir';
}

body[data-scrolltop='on'] .priceWallet .v-input__control .v-input__slot * {
  color: rgba(128, 132, 155, 0.93);
}

.priceWallet .v-input__control .v-input__slot {
  padding: 0 0.5rem;
  min-height: 2.5rem !important;
  height: 0rem !important;
  font-size: 1rem;
  margin: 0;
}

.priceWallet .v-input__control .v-input__slot:before {
  border-style: none
}

.priceWallet .v-input__control .v-input__slot:after {
  border-style: none
}

.priceWallet .v-input__control .v-input__prepend-inner {
  padding-left: 0;
}

.priceWallet .v-input__control .v-input__prepend-inner .append-icon {
  padding: 0;
}

.priceWallet .append-icon {
  background-color: white;
  -webkit-mask: url('/etebar.png') no-repeat center;
  mask: url('/etebar.png') no-repeat center;
  mask-size: 35px 20px;
  width: 45px;
  height: 20px !important;
}


body[data-scrolltop='on'] .priceWallet .append-icon {
  background-color: rgba(128, 132, 155, 0.93);
;
}


.priceWallet .v-input__control .v-input__prepend-inner {
  margin-top: 0 !important;
}

.priceWallet .v-input__control .v-text-field__slot {
  font-size: 1rem;
  align-items: center;
  margin: 0;
  padding: 0;
}

.priceWallet .v-input__control .v-text-field__slot .v-text-field__prefix {
  margin-top: 0.3rem;
}

.priceWallet .v-input__control .v-input__slot .v-input__append-inner {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 1.6rem;
}

.priceWallet .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--append {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 1.6rem;
}

.priceWallet .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--append .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 1.6rem;
}

body[data-scrolltop='on'] .on-scroll-shoed {
  color: rgb(126, 130, 153) !important;
  font-weight: normal !important;
}

body[data-scrolltop='on'] .priceWallet .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--append .v-icon {
  color: rgb(126, 130, 153);
}

body[data-scrolltop='on'] .priceWalletButton {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  background-color: #6cdb72!important;
  /*border-radius: 20%;*/
}
body[data-scrolltop='on'] #kt_header > div.d-flex.align-items-center.justify-content-between.container > div.topbar > div.d-flex.justify-content-ceter.mt-2.rounded > div > div   {
  /*border: 2px solid dodgerblue;*/
  background-color: rgba(128, 128, 128, 0.15) !important;


}
</style>
